import { useEffect, useState } from 'react'
import AnimationLayout from './components/AnimationLayout'

interface Badge {
  name: string
  emoji: string
  description: string
  points_awarded: number
}

interface Props {
  animation: { id: number; name: string; description: string }
  badge: Badge
  all_animations: { id: number; name: string }[]
}

export default function Animation28({ animation, badge, all_animations }: Props) {
  const [isRotating, setIsRotating] = useState(false)
  const [showText, setShowText] = useState(false)

  useEffect(() => {
    setTimeout(() => setIsRotating(true), 200)
    setTimeout(() => setShowText(true), 2500)
  }, [])

  return (
    <AnimationLayout animation={animation} allAnimations={all_animations}>
      <style>{`
        .perspective {
          perspective: 1000px;
        }
        @keyframes rotate3D {
          0% {
            transform: rotateY(0deg) rotateX(0deg);
          }
          25% {
            transform: rotateY(180deg) rotateX(10deg);
          }
          50% {
            transform: rotateY(360deg) rotateX(0deg);
          }
          75% {
            transform: rotateY(540deg) rotateX(-10deg);
          }
          100% {
            transform: rotateY(720deg) rotateX(0deg);
          }
        }
        @keyframes floatSlow {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-10px); }
        }
        .rotate-3d {
          animation: rotate3D 2s cubic-bezier(0.4, 0, 0.2, 1) forwards;
          transform-style: preserve-3d;
        }
        .float-slow {
          animation: floatSlow 3s ease-in-out infinite;
        }
      `}</style>

      <div className="flex flex-col items-center justify-center min-h-[50vh] sm:min-h-[60vh]">
        {/* Badge 3D */}
        <div className="perspective">
          <div className={`${isRotating ? 'rotate-3d' : ''} ${showText ? 'float-slow' : ''}`}>
            <div className="w-32 h-32 sm:w-44 sm:h-44 bg-tessan-cream rounded-2xl flex items-center justify-center shadow-2xl shadow-tessan-yellow/50 relative">
              <span className="text-6xl sm:text-8xl">{badge.emoji}</span>

              {/* Reflet 3D */}
              <div className="absolute inset-0 bg-gradient-to-br from-white/30 to-transparent rounded-2xl" />
            </div>
          </div>
        </div>

        <div className={`mt-8 text-center transition-all duration-700 ${showText ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
          <div className="text-2xl sm:text-4xl font-black text-tessan-yellow">{badge.name}</div>
          <div className="text-lg sm:text-xl text-tessan-cream mt-2">+{badge.points_awarded} points</div>
          <div className="text-tessan-cream/70 mt-4 max-w-[280px] sm:max-w-xs">{badge.description}</div>
        </div>
      </div>
    </AnimationLayout>
  )
}
